<template>
  <b-container :fluid="true" class="wd-approval-tab">
    <b-row>
      <b-col cols="12">
        <ag-grid-vue class="ag-theme-balham wd-approval-tab__grid"
                     :gridOptions="approvedTabGridOptions"
                     :columnDefs="approvedGrid.used_columns"
                     :rowData="approvedGrid.data"/>
      </b-col>
      <b-col class="text-center">
        <wd-pagination
            :grid="approvedGrid"
            :limit="searchPayload.limit"
            :offset="searchPayload.offset"
            @pageChanged="fetchApprovedTab"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapGetters, mapState } from 'vuex'
import { gridMixins } from '@/mixins'
import WdPagination from '@/components/common/WdPagination'

export default {
  name: 'ApprovalTab',
  mixins: [gridMixins],
  components: {
    WdPagination,
    'ag-grid-vue': AgGridVue
  },
  computed: {
    ...mapGetters('invoicesApproval', ['approvedTabGridOptions']),
    ...mapState('invoicesApproval', ['approvedGrid', 'searchPayload'])
  },
  methods: {
    async fetchApprovedTab (params) {
      await this.$store.dispatch('invoicesApproval/loadApprovedTab', { params })
    }
  }
}
</script>
<style lang="sass" scoped>
.wd-approval-tab
  &__btn-container
    text-align: right

  &__grid
    height: calc(100vh - 300px)
</style>



// WEBPACK FOOTER //
// src/components/common/invoices-approval/ApprovedTab.vue